import {ChangeDetectionStrategy, Component, computed, HostBinding, inject} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {Button, ButtonDirective, ButtonIcon} from "primeng/button";
import {RouterLink} from "@angular/router";
import {HomeyDialogService} from "../../../services/homey-dialog.service";
import {FeedbackDialogComponent} from "../../feedback-dialog/feedback-dialog.component";
import {environment} from "../../../../../environments/environment";
import {ABService} from "../../../services/a-b.service";
import {AnalyticsService} from "../../../services/analytics.service";

@Component({
  selector: 'homey-header-buttons',
  imports: [
    Button,
    ButtonDirective,
    ButtonIcon,
    RouterLink
  ],
  templateUrl: './header-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderButtonsComponent {
  @HostBinding('class') readonly hostClass = 'h-full flex flex-row gap-2 items-center';
  private readonly userService = inject(UserService);
  private readonly dialogService = inject(HomeyDialogService);
  private readonly abService = inject(ABService);
  private readonly analyticsService = inject(AnalyticsService);
  protected readonly user = this.userService.user;
  protected readonly feedbackButtonLabel = computed(() =>
    this.abService.feedbackButtonLabel() === 'suggestion' ? 'Suggestion' : 'Feedback'
  );

  public onFeedbackClick() {
    const variant = this.abService.feedbackButtonLabel();
    this.analyticsService.sendEvent('feedback-started', {variant});
    this.dialogService.showDialogWithHeader(FeedbackDialogComponent, variant === 'suggestion' ? 'Share your suggestion' : 'Share your feedback', {});
  }

  protected readonly environment = environment;
}
